// @core/api/endpoints/notifications/create_contact.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ContactResponse,
  CreateContactRequest,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Create contact
 * Creates a new contact entry for notification delivery. Contacts can be email addresses, phone numbers, or other addressable endpoints.
 */
export async function CreateContact(
  data: CreateContactRequest,
  options?: RequestOptions
): Promise<ContactResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/contacts`;
  const requestOptions = options;
  return client.post<ContactResponse>(requestPath, data, requestOptions);
}
